import { render } from "./ArgonPagination.vue?vue&type=template&id=09d5b594"
import script from "./ArgonPagination.vue?vue&type=script&lang=js"
export * from "./ArgonPagination.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__